<template>
    <div class="layer-context">
        <div
            class="menu-item"
            :class="{ 'disabled-menu-item': !layerContextStatus.canMoveUp || layerContextStatus.isBackGround }"
            @click.stop="layerContextStatus.canMoveUp && moveUpLayer()"
        >
            {{ $t("movUp") }}
        </div>
        <div
            class="menu-item"
            :class="{ 'disabled-menu-item': !layerContextStatus.canMoveDown || layerContextStatus.isBackGround }"
            @click.stop="layerContextStatus.canMoveDown && moveDownLayer()"
        >
            {{ $t("movDown") }}
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";

    @Component({})
    export default class LayerContext extends Vue {
        get layerContextStatus() {
            return this.$store.state.ui.layerContextStatus;
        }
        get layers() {
            return this.$store.state.page.activedPageLayers;
        }
        get selectLayerIndex() {
            return this.$store.state.ui.selectLayerIndex;
        }
        set selectLayerIndex(v) {
            this.$store.commit("setStatus", {
                type: "selectLayerIndex",
                data: v,
            });
        }
        moveUpLayer() {
            const i = this.layerContextStatus.index;
            this.layers.splice(i - 1, 2, this.layers[i], this.layers[i - 1]);
            window["_view"]._activePage.sortLayers(this.layers);
            this.$store.commit("closeContext");
            this.selectLayerIndex -= 1;
        }
        moveDownLayer() {
            const i = this.layerContextStatus.index;
            this.layers.splice(i, 2, this.layers[i + 1], this.layers[i]);
            window["_view"]._activePage.sortLayers(this.layers);
            this.$store.commit("closeContext");
            this.selectLayerIndex += 1;
        }
    }
</script>

<style lang="less">
    .layer-context {
        min-width: 166px;
        .menu-item {
            display: flex;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
</style>
<i18n>
{
    "zh": {
        "movUp": "上移",
        "movDown": "下移"
    },
    "en": {
        "movUp": "Move Up",
        "movDown": "Move Down"
    },
    "fr": {
        "movUp": "Déplacer vers le haut",
        "movDown": "Déplacer vers le bas"
    },
    "de": {
        "movUp": "Nach oben",
        "movDown": "Nach unten"
    },
    "jp": {
        "movUp": "上へ移動",
        "movDown": "下へ移動"
    },
    "es": {
        "movUp": "Mover arriba",
        "movDown": "Mover abajo"
    },
    "pt": {
        "movUp": "Mover para Cima",
        "movDown": "Mover para Baixo"
    },
    "it": {
        "movUp": "Sposta Su",
        "movDown": "Sposta Giù"
    },
    "tw": {
        "movUp": "上移",
        "movDown": "下移"
    }
}
</i18n>
